<template>
    <div>

        <v-alert v-if="errorAccess" border="start" border-color="red" density="compact" class="mb-4">
            {{ errorAccess }}
        </v-alert>
        <div v-else>
            <ListeAttenteDescription />

            <v-alert v-if="latokenError" border="start" border-color="red" density="compact" class="mb-4">
                {{ latokenError }}
            </v-alert>
            <v-progress-linear v-if="latokenLoading" indeterminate color="darkblue" class="mb-4"></v-progress-linear>

            <ListeAttenteForm v-if="!latokenError && !latokenLoading" v-model:mail="mail"
                v-model:selected-course="selected_course" v-model:tab="tab" :course-items="select_list_courses"
                :register-mail="latokenMail" @verify="handleVerify" @register="handleRegister" />

            <VerifyPositionDialog v-model="verifyDialog" :verify-result="verifyResult" :mail="mail"
                :has-liste-attente-bourse-privee="has_liste_attente_bourse_privee"
                @register-now="onRegisterFromVerifyDialog" />

            <RegisterListeAttenteDialog v-model="registerDialog" :register-result="registerResult" />
        </div>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";
import ListeAttenteDescription from "@/components/BourseDossards/ListeAttente/ListeAttenteDescription.vue";
import ListeAttenteForm from "@/components/BourseDossards/ListeAttente/ListeAttenteForm.vue";
import VerifyPositionDialog from "@/components/BourseDossards/ListeAttente/VerifyPositionDialog.vue";
import RegisterListeAttenteDialog from "@/components/BourseDossards/ListeAttente/RegisterListeAttenteDialog.vue";

export default {
    name: 'BourseDossardListListeAttente',
    components: {
        ListeAttenteDescription,
        ListeAttenteForm,
        VerifyPositionDialog,
        RegisterListeAttenteDialog,
    },
    computed: {
        ...mapStores(useMainStore),
        has_liste_attente_bourse_privee() {
            return this.mainStore.module.has_liste_attente_bourse_privee;
        },
        has_liste_attente_bourse() {
            return this.mainStore.module.has_liste_attente_bourse;
        },
        has_liste_attente_bourse_open() {
            return this.mainStore.module.has_liste_attente_bourse_open;
        },
        has_liste_attente_bourse_privee_open() {
            return this.mainStore.module.has_liste_attente_bourse_privee_open;
        },
        requiresLatoken() {
            const has_liste_attente_bourse = this.mainStore.module.has_liste_attente_bourse;
            const has_liste_attente_bourse_open = this.mainStore.module.has_liste_attente_bourse_open;
            if (!has_liste_attente_bourse || (has_liste_attente_bourse && !has_liste_attente_bourse_open)) {
                return true;
            }
            return false;
        },
        select_list_courses() {
            if (!this.mainStore.module.courses.has_courses) {
                return [];
            }
            let list_courses = this.mainStore.module.courses.list.map(course => {
                return {
                    title: course.nom,
                    value: course.id,
                }
            });
            list_courses.unshift({
                title: 'Sélectionner un parcours',
                value: null,
            });

            return list_courses;
        }
    },

    data() {
        return {
            errorAccess: null,
            tab: "verify",
            mail: "",
            selected_course: null,
            verifyDialog: false,
            registerDialog: false,
            verifyResult: null,
            registerResult: null,
            latokenLoading: false,
            latokenError: null,
            latokenResolved: false,
            latokenMail: null,
        }
    },

    methods: {

        checkAccess() {
            const has_liste_attente_bourse = this.mainStore.module.has_liste_attente_bourse;
            const has_liste_attente_bourse_open = this.mainStore.module.has_liste_attente_bourse_open;
            const has_liste_attente_bourse_privee = this.mainStore.module.has_liste_attente_bourse_privee;
            const has_liste_attente_bourse_privee_open = this.mainStore.module.has_liste_attente_bourse_privee_open;

            if (has_liste_attente_bourse_privee_open || has_liste_attente_bourse_open) {
                return;
            }


            if (!has_liste_attente_bourse && !has_liste_attente_bourse_privee) {
                this.errorAccess = "Il n'y a pas de liste d'attente pour cet événement.";
                return;
            }
            if (has_liste_attente_bourse_privee && !has_liste_attente_bourse_privee_open) {
                this.errorAccess = "La liste d'attente prioritaire n'est pas encore ouverte pour cet événement.";
                const date_ouverture_liste_attente_privee = this.mainStore.module.date_ouverture_liste_attente_privee;
                if (date_ouverture_liste_attente_privee) {
                    this.errorAccess += " Ouverture le " + date_ouverture_liste_attente_privee;
                }
                return;
            }
            if (has_liste_attente_bourse && !has_liste_attente_bourse_open) {
                this.errorAccess = "La liste d'attente n'est pas encore ouverte pour cet événement.";
                const date_ouverture_liste_attente_public = this.mainStore.module.date_ouverture_liste_attente_public;
                if (date_ouverture_liste_attente_public) {
                    this.errorAccess += " Ouverture le " + date_ouverture_liste_attente_public;
                }
                return;
            }


        },
        courseIdForSelect(id) {
            if (id == null || id === '') {
                return null;
            }
            const courses = this.mainStore.module.courses?.list || [];
            const course = courses.find(c => c.id == id);
            return course ? course.id : String(id);
        },
        async resolveLatoken() {
            const latoken = this.$route.query.latoken;
            if (this.requiresLatoken && (!latoken || latoken === '')) {
                this.latokenError = "Ce lien n'est pas valide.";
                return;
            }
            if (!latoken || latoken === '') {
                if (this.mainStore.module.courses.has_courses) {
                    this.selected_course = this.select_list_courses[0].value;
                }
                return;
            }
            if (latoken === 'a0JmME5IZWFlV3dhbDEvRkhkVExJdz09') {
                this.latokenResolved = true;
                return;
            }
            this.latokenLoading = true;
            const id_module = this.mainStore.module.id;
            const data = await PublicService.getListeAttenteByLatoken(latoken, id_module);
            this.latokenLoading = false;
            if (!data || !data.mail) {
                this.latokenError = "Une erreur est survenue. Ce lien n'est pas valide.";
                return;
            }
            this.latokenMail = data.mail;
            this.mail = data.mail;
            this.selected_course = this.courseIdForSelect(data.id_course);
            this.latokenResolved = true;
        },
        async handleVerify() {
            const id_module = this.mainStore.module.id;
            let request = await PublicService.verifyListeAttente(this.mail, this.selected_course, id_module, false);
            if (!request) {
                this.mainStore.notification.send("Erreur lors de la vérification de votre position", "error");
                return;
            }
            this.verifyResult = request;
            this.verifyDialog = true;
        },
        async handleRegister() {
            const id_module = this.mainStore.module.id;
            const mail = this.latokenMail ?? this.mail;
            let request = await PublicService.verifyListeAttente(mail, this.selected_course, id_module, true);
            if (!request) {
                this.mainStore.notification.send("Erreur lors de l'inscription en liste d'attente", "error");
                return;
            }
            this.registerResult = request;
            this.registerDialog = true;
        },
        onRegisterFromVerifyDialog() {
            this.verifyDialog = false;
            this.tab = 'register';
            this.handleRegister();
        },
    },

    mounted() {
        this.checkAccess();
        this.resolveLatoken();
    },
}
</script>

<style lang="scss" scoped></style>
